import { render } from "./DateGroup.vue?vue&type=template&id=b5d9f0b0&scoped=true"
import script from "./DateGroup.vue?vue&type=script&lang=js"
export * from "./DateGroup.vue?vue&type=script&lang=js"

import "./DateGroup.vue?vue&type=style&index=0&id=b5d9f0b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d9f0b0"]])

export default __exports__